export default __webpack_public_path__ + "static/media/3387.f677a480.png";